import { SHARED_STEPS } from './shared.steps';
import { backButton, nextButton, openPanel, closePanel } from '../tourButtons';

export function getMonitoringSteps(t) {
  return [
    SHARED_STEPS.welcome(t),
    SHARED_STEPS.sidebar(t),
    {
      id: 'dashboard-map',
      attachTo: { element: '[data-tour="map"]', on: 'right' },
      title: t('tour.map.title'),
      text: t('tour.map.text'),
      buttons: [backButton(t), nextButton(t)],
    },
    {
      id: 'pollutant-filter',
      attachTo: { element: '[data-tour="pollutants"]', on: 'left' },
      title: t('tour.pollutantFilter.title'),
      text: t('tour.pollutantFilter.text'),
      beforeShowPromise: openPanel('[data-tour="pollutants"]', '[data-tour="map-pollutant-btn"]'),
      when: closePanel('[data-tour="pollutants"]', '[data-tour="map-pollutant-btn"]'),
      buttons: [backButton(t), nextButton(t)],
    },
    {
      id: 'provider-filter',
      attachTo: { element: '[data-tour="map-providers"]', on: 'left' },
      title: t('tour.providerFilter.title'),
      text: t('tour.providerFilter.text'),
      beforeShowPromise: openPanel('[data-tour="map-providers"]', '[data-tour="map-provider-btn"]'),
      when: closePanel('[data-tour="map-providers"]', '[data-tour="map-provider-btn"]'),
      buttons: [backButton(t), nextButton(t)],
    },

    {
      id: 'alerts',
      attachTo: { element: '[data-tour="nav-alerts"]', on: 'right' },
      title: t('tour.alerts.title'),
      text: t('tour.alerts.text'),
      buttons: [backButton(t), nextButton(t)],
    },
    {
      id: 'reports',
      attachTo: { element: '[data-tour="nav-reports"]', on: 'right' },
      title: t('tour.reports.title'),
      text: t('tour.reports.text'),
      buttons: [backButton(t), nextButton(t)],
    },
    {
      id: 'device-management',
      attachTo: { element: '[data-tour="nav-devices"]', on: 'right' },
      title: t('tour.devices.title'),
      text: t('tour.devices.text'),
      buttons: [backButton(t), nextButton(t)],
    },
    {
      id: 'data-sharing',
      attachTo: { element: '[data-tour="nav-dataSharing"]', on: 'right' },
      title: t('tour.dataSharing.title'),
      text: t('tour.dataSharing.text'),
      buttons: [backButton(t), nextButton(t)],
    },

    SHARED_STEPS.settings(t),
    SHARED_STEPS.help(t),
    SHARED_STEPS.done(t),
  ];
}